import { z } from 'zod';
import { LinkableResource } from '../primitives/linkable-kind.js';
export const SearchScope = z.enum([
    'all',
    'articles',
    'files',
    'folders',
    'groups',
    'members',
    'forum',
    'comments',
    'annotations',
    'surveys',
    'calendar',
    'scheduling',
    'coordination',
    'bookmarks',
    'newsletters',
    'taxonomy',
]);
export const SearchHit = z.object({
    scope: SearchScope.exclude(['all']),
    resource: LinkableResource,
    score: z.number().nonnegative(),
    matchedFields: z.array(z.string().min(1)),
});
export const SearchResponse = z.object({
    q: z.string(),
    scope: SearchScope,
    hits: z.array(SearchHit),
    total: z.number().int().nonnegative(),
    limit: z.number().int().nonnegative(),
    offset: z.number().int().nonnegative(),
});
export const SearchSuggestion = z.object({
    scope: SearchScope.exclude(['all']),
    label: z.string(),
    url: z.string(),
    resource: LinkableResource,
});
export const SearchSuggestionsResponse = z.object({
    q: z.string(),
    suggestions: z.array(SearchSuggestion),
});
//# sourceMappingURL=search.js.map